import { shutdown } from '@intercom/messenger-js-sdk';

type LoginArgs = {
  token: string;
  email?: string;
};

// User Access Token
const ACCESS_TOKEN_KEY = 'session-token';
// Pre-User Session Access Token
const VISITOR_ACCESS_TOKEN_KEY = 'visitor-token';
const VISITOR_EMAIL_KEY = 'visitor-email';
export const INVITE_CODE_KEY = 'invite-code';
export const VISITOR_FIRST_NAME_KEY = 'visitor-first-name';
export const VISITOR_LAST_NAME_KEY = 'visitor-last-name';

function login(args: LoginArgs) {
  return localStorage.setItem(ACCESS_TOKEN_KEY, args.token);
}

function loginVisitor(args: LoginArgs) {
  if (args.email) {
    return localStorage.setItem(VISITOR_EMAIL_KEY, args.email);
  }
  return localStorage.setItem(VISITOR_ACCESS_TOKEN_KEY, args.token);
}

function logout() {
  shutdown();
  return localStorage.removeItem(ACCESS_TOKEN_KEY);
}

function logoutVisitor() {
  return localStorage.removeItem(VISITOR_ACCESS_TOKEN_KEY);
}

function clearVisitor() {
  localStorage.removeItem(VISITOR_EMAIL_KEY);
  localStorage.removeItem(VISITOR_FIRST_NAME_KEY);
  localStorage.removeItem(VISITOR_LAST_NAME_KEY);
  return logoutVisitor();
}

function isLoggedIn() {
  return !!localStorage.getItem(ACCESS_TOKEN_KEY);
}

function isVisitorLoggedIn() {
  return !!localStorage.getItem(VISITOR_ACCESS_TOKEN_KEY);
}

function getToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

function getVisitorToken() {
  return localStorage.getItem(VISITOR_ACCESS_TOKEN_KEY);
}

function getInviteCode() {
  return localStorage.getItem(INVITE_CODE_KEY);
}

function setInviteCode(code: string) {
  return localStorage.setItem(INVITE_CODE_KEY, code);
}

function clearInviteCode() {
  return localStorage.removeItem(INVITE_CODE_KEY);
}

function getVisitorEmail() {
  return localStorage.getItem(VISITOR_EMAIL_KEY);
}

function setVisitorEmail(email: string) {
  return localStorage.setItem(VISITOR_EMAIL_KEY, email);
}

function getVisitorFirstName() {
  return localStorage.getItem(VISITOR_FIRST_NAME_KEY);
}

function setVisitorFirstName(firstName: string) {
  return localStorage.setItem(VISITOR_FIRST_NAME_KEY, firstName);
}

export default {
  login,
  logout,
  isLoggedIn,
  getToken,
  getInviteCode,
  setInviteCode,
  getVisitorToken,
  loginVisitor,
  logoutVisitor,
  isVisitorLoggedIn,
  getVisitorEmail,
  setVisitorEmail,
  clearInviteCode,
  getVisitorFirstName,
  setVisitorFirstName,
  clearVisitor,
};
